/**
 * Status badge + Need attention helpers for consultant operational surfaces.
 * Normative: R-7544, R-7546 (Access unknown > Access blocked > Inactive > Active).
 */

const REPORT_STATUS_ATTENTION = new Set(['not_on_platform', 'not_started', 'in_progress']);

/**
 * Resolve the single Status Badge for a Clients & progress row.
 * @param {object} row
 * @returns {{ key: string, label: string, className: string, lockReason?: string|null }}
 */
export const resolveStatusBadge = (row) => {
  const usability = row?.usability;
  if (usability === 'unknown') {
    return { key: 'access_unknown', label: 'Access unknown', className: 'bg-muted text-muted-foreground' };
  }
  if (usability === 'blocked' || (!usability && row?.accessBlocked)) {
    return {
      key: 'access_blocked',
      label: 'Access blocked',
      className: 'bg-danger-bg text-danger',
      lockReason: row?.lockReason || null,
    };
  }
  if (row?.inactiveFlag) {
    return { key: 'inactive', label: 'Inactive', className: 'bg-warning-bg text-warning' };
  }
  return { key: 'active', label: 'Active', className: 'bg-success-bg text-success' };
};

/**
 * First matching Attention Reason (R-7544 order).
 * @param {object} row
 * @returns {string|null}
 */
export const attentionReason = (row) => {
  if (!row) return null;
  if (row.usability === 'unknown') return 'Access unknown';
  if (row.usability === 'blocked' || (!row.usability && row.accessBlocked)) return 'Access blocked';
  if (row.inactiveFlag) return 'Inactive';
  if (!row.ownerUserId) return 'No account manager';
  if (REPORT_STATUS_ATTENTION.has(row.reportStatus)) {
    if (row.reportStatus === 'not_on_platform') return 'Not on platform';
    if (row.reportStatus === 'not_started') return 'Not started';
    if (row.reportStatus === 'in_progress') return 'In progress';
  }
  return null;
};

/**
 * Whether a client row should appear under "Need attention" (R-7544).
 * @param {object} row
 * @returns {boolean}
 */
export const needsAttention = (row) => attentionReason(row) != null;

/**
 * Completeness cell: never a percentage (R-7536 / R-7900).
 * @param {object} row
 * @returns {string}
 */
export const formatCompletenessCell = (row) => {
  if (row?.definitelyMissingCount != null && Number.isFinite(Number(row.definitelyMissingCount))) {
    const n = Number(row.definitelyMissingCount);
    return `${n} definitely missing`;
  }
  if (row?.completenessLists?.definitelyMissing?.length != null) {
    const n = row.completenessLists.definitelyMissing.length;
    return `${n} definitely missing`;
  }
  return 'Not computed';
};
